import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { LoadingScheduling } from 'interfaces/loadingChecklist';
import { UnloadingScheduling } from '@/interfaces/unloadingChecklist';
import { Transport } from 'interfaces/transport';

export interface ChecklistState {  
  loadingChecklist: LoadingScheduling | null;
  unloadingChecklist: UnloadingScheduling | null;
  transport: Transport | null;
}

export interface SetChecklistAction {
  data: UnloadingScheduling | LoadingScheduling | Transport;
}

const { Types, Creators } = createActions(
  {
    setData: ['data'],
    reset: [],
  },
  { prefix: 'PRINTING_DATA_' }
);

const INITIAL_STATE: ChecklistState = {
  loadingChecklist: null,
  unloadingChecklist: null,
  transport: null,
};

const setData = (state: ChecklistState, action: SetChecklistAction) =>
  update(state, {
    loadingChecklist: { $set: action.data as LoadingScheduling },
    unloadingChecklist: { $set: action.data as UnloadingScheduling },
    transport: { $set: action.data as Transport },
  });

const reset = (state: ChecklistState) =>
  update(state, {
    loadingChecklist: { $set: INITIAL_STATE.loadingChecklist },
    unloadingChecklist: { $set: INITIAL_STATE.unloadingChecklist },
    transport: { $set: INITIAL_STATE.transport },
  });

export const printingData = createReducer(INITIAL_STATE, {
  [Types.SET_DATA]: setData,
  [Types.RESET]: reset,
});

export const PrintingTypes = Types;
export const PrintingActions = Creators;
